import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers, { initParams, initData } from './reducers/reducers';
import App from './components/App/App';
import './index.css';

// the id of the div to render too
let appId = `${process.env.REACT_APP_APP_ID}` ? `${process.env.REACT_APP_APP_ID}` : 'capgainsestimator';

// load attributes from script tag
function getSyncScriptParams() {
  initParams.wtRegion = `${window[appId].wtRegion}` && `${window[appId].wtRegion}` !== 'undefined' ? `${window[appId].wtRegion}` : "US";
  initParams.dataspanApiUrl = `${process.env.REACT_APP_API_URL}`; 
  initParams.dpdApiUrl = `${process.env.REACT_APP_DPD_URL}`; 
  initParams.initialTickers = `${window.location.search}`.split('tickers=')[1] ? (`${window.location.search}`.split('tickers=')[1]).split(',') : null;
  initParams.showWTSwapsWithCapGains = `${process.env.REACT_APP_SHOW_WT_SWAPS_WITH_CAPGAINS}` && 
    `${process.env.REACT_APP_SHOW_WT_SWAPS_WITH_CAPGAINS}` === 'true' ? true : false;
  initParams.version = `${process.env.REACT_APP_VERSION}` ? `${process.env.REACT_APP_VERSION}` : 'VDEV';
  
  if (window.capgainsestimator) {
    initParams.showWTUnpublishedMsg = window.capgainsestimator.showWTUnpublishedMsg;
  } else {
    initParams.showWTUnpublishedMsg = false;
  }

}
getSyncScriptParams(); 

let mountedContainer = null;

function renderApp(container) {
  mountedContainer = container;
  ReactDOM.render((
    <BrowserRouter>
      <Provider store={createStore(reducers, { 'params': initParams, 'fundData': initData }, applyMiddleware(thunk))}>
        <App />
      </Provider>
    </BrowserRouter>
  ), container);
}

// The host page (dpd-platform-ui) loads this bundle via a script tag with no
// guaranteed order relative to its own render, so the container may not exist
// in the DOM yet when this script runs. Wait for it instead of crashing on a
// null container.
function syncMount() {
  const container = document.getElementById(appId);
  if (container && container !== mountedContainer) {
    renderApp(container);
  }
}

new MutationObserver(syncMount).observe(document.documentElement, {
  childList: true,
  subtree: true,
});

syncMount();